<template>
  <LogInComponent />
</template>

<script>
import LogInComponent from '@/components/pagesComponents/login/LogInComponent.vue'
import viewMI from '@/mixins/viewMI.js'

export default {
    data(){
        return {
            
        }
    },      
    mixins: [viewMI],    
    components:{
        LogInComponent            
    },
    methods:{
        userReady(){
            //if the user is logged in and the route is the home route, go to the dashboard
            this.$router.push({name: 'Dashboard'})
        }
    }
}
</script>
